var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"we-tree"},_vm._l((_vm.root.computedNodes),function(node,key){return _c('we-tree-node',{key:_vm.getNodeKey(node, key),attrs:{"node":node,"fs-type":_vm.fsType,"is-root-default-open":node._level === 1 ? _vm.isRootDefaultOpen : false,"highlight-path":_vm.highlightPath,"before-remove":_vm.beforeRemove}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }